import React, { useEffect, useState } from "react";
import Navbar from "../navigation/navbar";
import Footer from "../navigation/footer";
import Contact from "../navigation/footercontact";
import fondo from "../../assets/images/fondo.png";
import N1 from "../../assets/images/N1.png";
import N2 from "../../assets/images/N2.png";
import N3 from "../../assets/images/N3.png";
import { motion } from "framer-motion";

const Nosotros = () => {

  useEffect(() => {
    // Esto hará que el scroll vuelva al inicio al montar el componente
    window.scrollTo(0, 0);
}, []); // Dependencia vacía para que se ejecute solo una vez cuando el componente se monta

const pageTransition = {
  initial: { opacity: 0, x: 100 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 100 },
  transition: { duration: 1 }
};

const [activeTab, setActiveTab] = useState('about');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };


  return (
    <motion.div
    initial="initial"
    animate="animate"
    exit="exit"
    variants={pageTransition}
    >
      {/* navbar  */}
      <div className="container mx-auto">
        <Navbar />
      </div>

      {/* Hero */}
      <div className="relative w-full">
        <img
          className="absolute object-cover w-full h-64"
          src={fondo}
          alt="Fondo Landing Page"
        />
        <div className="container relative flex flex-col justify-center h-64 px-8 pt-20 mx-auto xl:px-24">
          <h1 className="text-4xl font-bold text-white">Nosotros</h1>

          {/* BreadCrumb */}
          <nav class="flex pt-2" aria-label="Breadcrumb">
            <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
              <li class="inline-flex items-center">
                <a
                  href="/"
                  class="inline-flex items-center text-sm font-normal text-white hover:text-blue-600 "
                >
                  <svg
                    class="w-3 h-3 me-2.5"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
                  </svg>
                  Inicio
                </a>
              </li>
              <li>
                <div class="flex items-center">
                  <svg
                    class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 6 10"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 9 4-4-4-4"
                    />
                  </svg>
                  <a
                    href="/nosotros"
                    class="ms-1 text-sm text-white font-semibold hover:text-blue-600 md:ms-2 dark:text-gray-400 dark:hover:text-white"
                  >
                    Nosotros
                  </a>
                </div>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Quienes somos */}
      <div className="flex items-center justify-center w-full bg-white lg:px-24 p-14">
        <div className="container flex flex-col items-center justify-center mx-auto lg:flex-row">
          {/* Texto  */}
          <div className="lg:w-1/2">
            <h2 className="py-4 text-2xl font-bold text-darkblue md:text-2xl lg:text-3xl">
              ¿Quiénes somos?
            </h2>
            <p className="text-lg leading-7 text-justify md:leading-8 lg:leading-9 md:text-lg lg:text-xl">
            NDT Technical Solutions Costa Rica S.A., fundada en 2008, se ha consolidado como líder en pruebas no destructivas (NDT) en la región. Ofrecemos soluciones avanzadas de inspección y análisis en sectores como la industria aeronáutica, automotriz, ferroviaria y de energía. Nuestro enfoque se centra en garantizar la calidad, seguridad e integridad de equipos y componentes a través de técnicas especializadas y tecnología de punta.
            </p>
          </div>
          <div className="flex items-center justify-center w-full py-12 lg:py-8 lg:w-1/2">
            <img src={N1} alt="Imagen de referencia" className=" lg:w-2/3" />
          </div>
        </div>
      </div>

      {/* Historia */}
      <div className="flex items-center justify-center w-full bg-gray-200 lg:px-24 p-14">
        <div className="container flex flex-col-reverse items-center justify-center mx-auto lg:flex-row">
          <div className="flex items-center justify-center w-full py-12 lg:py-8 lg:w-1/2">
            <img src={N2} alt="Imagen de referencia" className=" lg:w-2/3" />
          </div>

          {/* Texto  */}
          <div className="lg:w-1/2">
            <h2 className="py-4 text-2xl font-bold text-darkblue md:text-2xl lg:text-3xl">
              Historia de NDT
            </h2>
            <p className="text-lg leading-7 text-justify md:leading-8 lg:leading-9 md:text-lg lg:text-xl">
            Desde su creación, NDT Technical Solutions ha revolucionado el mercado de NDT en Costa Rica y en otros países, expandiendo su alcance a diversos sectores industriales y colaborando con entidades gubernamentales. A lo largo de los años, nos hemos distinguido por nuestra capacidad de adaptar tecnologías avanzadas y cumplir con rigurosos estándares internacionales.
            </p>
          </div>
        </div>
      </div>

      {/* Contribuciones */}
      <div className="flex items-center justify-center w-full bg-white lg:px-24 p-14">
        <div className="container flex flex-col items-center justify-center mx-auto lg:flex-row">
          {/* Texto  */}
          <div className="lg:w-1/2">
            <h2 className="py-4 text-2xl font-bold text-darkblue md:text-2xl lg:text-3xl">
              Compromiso con la industria
            </h2>
            <p className="text-lg leading-7 text-justify md:leading-8 lg:leading-9 md:text-lg lg:text-xl">
            Con más de 15 años de experiencia, NDT Technical Solutions Costa Rica S.A. se ha posicionado como líder en la industria de pruebas no destructivas, tanto a nivel nacional como internacional. Somos la única empresa en Costa Rica afiliada a la ASNT, lo que respalda nuestro compromiso con los más altos estándares de calidad y mejores prácticas. Contamos con un equipo de técnicos e ingenieros altamente calificados (Niveles I, II y III) y ofrecemos servicios portátiles para mayor flexibilidad. Como pioneros en el sector, garantizamos inspecciones precisas y seguras, prolongando la vida útil de equipos y componentes y asegurando la integridad y la eficiencia de las operaciones de nuestros clientes.
            </p>
          </div>
          <div className="flex items-center justify-center w-full py-12 lg:py-8 lg:w-1/2">
            <img src={N3} alt="Imagen de referencia" className=" lg:w-2/3" />
          </div>
        </div>
      </div>

      {/* Nuestro compromiso  */}
      <div className="flex flex-col w-full bg-white p-14 lg:px-24">
        <h2 className="w-full text-2xl font-bold md:text-3xl lg:text-4xl text-darkblue">Nuestro compromiso</h2>
        {/* mvv  */}
        <div className="flex flex-col w-full py-8 lg:space-x-14 lg:flex-row">
          {/* mision vision  */}
          <div className="flex flex-col lg:w-1/2 lg:pr-4">
          {/* mision  */}
          <div>

            <h3 className="py-4 pr-4 text-lg font-bold border-b-8 w-fit border-lightblue text-darkblue md:text-xl lg:text-2xl">
              Misión
            </h3>
            <p className="py-4 text-lg text-justify text-darkblue md:text-xl">
            Brindar soluciones avanzadas en pruebas no destructivas (NDT) e inspección, utilizando tecnología de vanguardia para garantizar la seguridad, calidad y eficiencia de los componentes e infraestructuras de nuestros clientes en múltiples sectores industriales, asegurando siempre la integridad y confiabilidad de sus operaciones.
            </p>
          </div>
          {/* vision  */}
          <div>

            <h3 className="py-4 pr-4 text-lg font-bold border-b-8 w-fit border-lightblue text-darkblue md:text-xl lg:text-2xl">
              Visión
            </h3>
            <p className="py-4 text-lg text-justify text-darkblue md:text-xl">
            Ser líderes en la región como la empresa más confiable y competente en servicios de NDT, expandiendo nuestra presencia y ofreciendo un servicio de calidad internacionalmente reconocido que impulse la seguridad y sostenibilidad en la industria.
            </p>
          </div>
          </div>
          {/* valores  */}
          <div className="flex flex-col lg:w-1/2">
          <div>

            <h3 className="py-4 pr-4 text-lg font-bold border-b-8 w-fit border-lightblue text-darkblue md:text-xl lg:text-2xl">
              Valores
            </h3>
            {/* valores punto a punto */}
            <div className="flex flex-col py-4 space-y-5">

            <div>
              <h4 className="text-xl font-semibold text-darkblue">Compromiso</h4>
            <p className="text-lg text-darkblue md:text-xl">
            Comprometidos con la excelencia y la mejora continua en todos nuestros servicios.
           </p>
            </div>
            <div>
              <h4 className="text-xl font-semibold text-darkblue">Integridad</h4>
            <p className="text-lg text-darkblue md:text-xl">
            Actuamos con transparencia y ética en cada proceso y relación.
          </p>
            </div>
            <div>
              <h4 className="text-xl font-semibold text-darkblue">Calidad</h4>
            <p className="text-lg text-darkblue md:text-xl">
            Aseguramos que nuestros servicios cumplan con los más altos estándares de calidad y seguridad.
    </p>
            </div>
            <div>
              <h4 className="text-xl font-semibold text-darkblue">Innovación</h4>
            <p className="text-lg text-darkblue md:text-xl">
            Adoptamos tecnología avanzada y mejores prácticas para mantenernos a la vanguardia.
          </p>
            </div>
            </div>
          </div>

          </div>
        </div>
      </div>

      {/* NDT  */}
      <div className="pt-0 bg-white p-14 lg:px-14">
      <h2 className="max-w-5xl pb-8 mx-auto text-2xl font-bold md:text-3xl lg:text-4xl text-darkblue">Además de NDT, ofrecemos:
      </h2>

      <ul className="flex flex-wrap max-w-5xl mx-auto text-sm font-medium text-center text-white border-b border-gray-200 rounded-t-lg bg-gradient-to-r from-lightblue to-lightblue2" role="tablist">
        <li className="me-2">
          <button
            onClick={() => handleTabClick('about')}
            className={`inline-block p-4 hover:text-lightblue2 hover:bg-gray-100 ${activeTab === 'about' ? 'bg-gray-100 text-lightblue2' : ''}`}
            role="tab"
            aria-controls="about"
            aria-selected={activeTab === 'about'}
          >
            Acerca de
          </button>
        </li>
        <li className="me-2">
          <button
            onClick={() => handleTabClick('services')}
            className={`inline-block p-4 hover:text-lightblue2 hover:bg-gray-100 ${activeTab === 'services' ? 'bg-gray-100 text-lightblue2' : ''}`}
            role="tab"
            aria-controls="services"
            aria-selected={activeTab === 'services'}
          >
            Servicios
          </button>
        </li>
      </ul>

      <div id="defaultTabContent" className="max-w-5xl mx-auto">
        {/* Nosotros Tab */}
        {activeTab === 'about' && (
          <div className="p-4 rounded-lg rounded-t-none bg-gray-50 md:p-8 dark:bg-gray-800" id="about" role="tabpanel">
            <h2 className="mb-3 text-3xl font-bold tracking-tight text-darkblue dark:text-white">
              Servicios Profesionales de Aviación - Seproa S.A.
            </h2>
            <p className="mb-3 text-gray-500 dark:text-gray-400">
            Con más de 20 años de experiencia, SEPROA S.A. se ha consolidado como la primera empresa certificadora de compañías aéreas en Costa Rica y fuera de nuestras fronteras, abarcando todas las modalidades técnicas de la industria de la aviación. Nos especializamos en capacitar, certificar y asesorar para asegurar los más altos estándares de seguridad y calidad en el sector aeronáutico.
            </p>
            <a href="https://seproacr.com" target="blank" className="inline-flex items-center font-medium text-blue-600 hover:text-blue-800 dark:text-blue-500 dark:hover:text-blue-700">
              Conocer más
              <svg className="w-2.5 h-2.5 ms-2 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/>
              </svg>
            </a>
          </div>
        )}

        {/* Services Tab */}
        {activeTab === 'services' && (
          <div className="p-4 bg-white rounded-lg md:p-8" id="services" role="tabpanel">
            <h2 className="mb-5 text-lg font-bold tracking-tight text-darkblue lg:text-2xl">
            Nuestros servicios destacados incluyen:
            </h2>
            <ul role="list" className="space-y-4 text-gray-500 dark:text-gray-400">
              <li className="flex items-center space-x-2 rtl:space-x-reverse">
                <svg className="flex-shrink-0 w-3.5 h-3.5 text-blue-600 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                <span className="leading-tight">Consultoría integral en procesos aeronáuticos</span>
              </li>
              <li className="flex items-center space-x-2 rtl:space-x-reverse">
                <svg className="flex-shrink-0 w-3.5 h-3.5 text-blue-600 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                <span className="leading-tight">Proceso de certificación de compañías aeronáuticas</span>
              </li>
              <li className="flex items-center space-x-2 rtl:space-x-reverse">
                <svg className="flex-shrink-0 w-3.5 h-3.5 text-blue-600 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                <span className="leading-tight">Capacitación especializada en seguridad operacional</span>
              </li>
              <li className="flex items-center space-x-2 rtl:space-x-reverse">
                <svg className="flex-shrink-0 w-3.5 h-3.5 text-blue-600 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                <span className="leading-tight">Gestión de trámites aeronáuticos
                </span>
              </li>
              <li className="flex items-center space-x-2 rtl:space-x-reverse">
                <svg className="flex-shrink-0 w-3.5 h-3.5 text-blue-600 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                <span className="leading-tight">Entre otros.
                </span>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>

      <Contact />
      <Footer />

    </motion.div>
  );
};

export default Nosotros;
